import { defineComponent, ref, watch, computed } from 'vue';
import HetaoLogoNoc from '@/assets/image/home/logo_noc.png';
import LogoBlue from '@/assets/image/home/logo_blue.png';
import HetaoDefaultAvatar from '@/assets/image/home/contest/default-avatar.png';
import { EnvironmentOutlined } from '@ant-design/icons-vue';
import { useRouter, useRoute } from 'vue-router';
import { LoginService } from '@/services/login.service';
import { UserService } from '@/services/user.service';
import { useService } from '@kaokei/use-vue-service';
import { SHOW_BRAND, getOtherLoginUrl } from '@/utils';
export default defineComponent({
  name: 'ContestHeader',
  components: {
    EnvironmentOutlined: EnvironmentOutlined
  },
  setup: function () {
    var selectedKeys = ref([]);
    var route = useRoute();
    var router = useRouter();
    var userService = useService(UserService);
    var loginService = useService(LoginService);
    var logout = function () {
      userService.logout();
      // if (route.meta?.logoutPath) {
      //   const newQuery = route.meta?.ignoreQuery ? {} : route.query;
      //   router.replace({
      //     path: route.meta.logoutPath as string,
      //     query: newQuery,
      //   });
      // }
    };
    watch(function () {
      return userService.user;
    }, function (user) {
      if (!(user && user.userId)) {
        if (route.meta && route.meta.auth) {
          var otherLoginUrl = getOtherLoginUrl();
          if (otherLoginUrl) {
            window.location.replace(otherLoginUrl);
            // clearOtherLoginUrl();
            return;
          }
          router.replace({
            name: route.meta.loginUrlName
          });
        }
      }
    });
    var isBlueTheme = computed(function () {
      var _a;
      return (_a = route.meta) === null || _a === void 0 ? void 0 : _a.isBlueTheme;
    });
    var hideLogo = computed(function () {
      var _a;
      return (_a = route.meta) === null || _a === void 0 ? void 0 : _a.hideLogo;
    });
    var HetaoLogoFinal = computed(function () {
      if (isBlueTheme.value) {
        return LogoBlue;
      }
      return HetaoLogoNoc;
    });
    var HetaoLogoHeight = computed(function () {
      if (isBlueTheme.value) {
        return 20;
      }
      return 31;
    });
    var goLoginPage = function () {
      var otherLoginUrl = getOtherLoginUrl();
      if (otherLoginUrl) {
        window.location.replace(otherLoginUrl);
        // clearOtherLoginUrl();
        return;
      }
      router.push({
        name: route.meta.loginUrlName
      });
    };
    var hideAvatar = computed(function () {
      var _a;
      return (_a = route.meta) === null || _a === void 0 ? void 0 : _a.hideAvatar;
    });
    return {
      HetaoLogoFinal: HetaoLogoFinal,
      selectedKeys: selectedKeys,
      loginService: loginService,
      userService: userService,
      logout: logout,
      SHOW_BRAND: SHOW_BRAND,
      goLoginPage: goLoginPage,
      HetaoDefaultAvatar: HetaoDefaultAvatar,
      HetaoLogoHeight: HetaoLogoHeight,
      hideAvatar: hideAvatar,
      isBlueTheme: isBlueTheme,
      hideLogo: hideLogo
    };
  }
});